class Source {
  constructor() {
    this.current = null
    this.isExternal = false
    this._keepBehind = false
    this.name = null
    this.platform = ["MAIN", "VOD", "HLS", "MULTICAST", "RF"]
    this.inputs = {
      MAIN: null,
      VOD: null,
      HLS: null,
      MULTICAST: null,
      RF: null,
      HDMI1: null,
      HDMI2: null,
      HDMI3: null,
      HDMI4: null
    }
    this.timeout = null
  }
  async _init() {
    Object.assign(this.inputs, __._source.inputs)
    Object.keys(this.inputs).forEach(key => {
      if (!this.inputs[key]) delete this.inputs[key]
    })

    _$.vue.$on("source", e => this._sourceHandler(e))

    this.current = await this._get()
    if (!this.current) throw "Unable to get device source"

    this.name = _$.getKeyByValue(this.inputs, this.current) || "UNKNOWN"

    return true
  }
  async select() {
    const menus = Object.keys(_$.clone(this.inputs)),
      sources = []

    menus.filter(key => this.platform.indexOf(key) < 0 && this.inputs[key]).forEach(key => sources.push({ key: this.inputs[key], value: key }))
    const res = await _$.vue.$sidepane("Source", null, sources)

    if (!res) return false
    return this.set(res)
  }
  async set(source) {
    if (this.timeout) _$.removeTimeout(this.timeout)

    if (!_$.getKeyByValue(this.inputs, source)) return false
    if (this.current === source) return true

    _$.nav.disable()
    _$.vue.$emit("actions", "pause")

    this.isExternal = true
    __.platform.focus = false
    __.platform.saveState()
    await __.media.destroy()

    if (!this.isPlatformSource(source)) this._resizeTvWindowForSource("external")

    const promise = await _$.progress.create()

    _$.vue.$off("sourceChanged").$on("sourceChanged", () => promise.resolve())

    const res = await __._source.set(source).catch(err => _$.error(err))

    if (!res) {
      promise.reject()
      if (this.timeout) _$.removeTimeout(this.timeout)
      this.timeout = _$.makeTimeout(() => this._toPlatform(), 3000)
    }

    return promise.done
  }
  async setByName(name, keepBehind = false) {
    if (!this.inputs[name]) return false

    this._keepBehind = keepBehind
    return __.source.set(this.inputs[name])
  }
  async _get() {
    return __._source.get().catch(err => _$.error(err))
  }

  /* Helpers */
  isPlatformSource(source) {
    if (!source) source = this.current

    const key = _$.getKeyByValue(this.inputs, source.toString())
    if (!key) return false

    if (this.platform.indexOf(key) < 0) return false

    return true
  }
  _isEmbeddable() {
    return __._source.embeddable ? true : false
  }
  _resizeTvWindowForSource(type) {
    if (type === "external") __.common.tvWindowResize("externalInputFrame", !this._keepBehind)
    else if (type === "platform") __.platform.getState("metrics") ? __.platform.loadState("metrics") : __.common.tvWindowResize()

    return true
  }
  _sourceHandler(e) {
    if (typeof e !== "object") return false
    if (this.timeout) _$.removeTimeout(this.timeout)

    const oldSource = this.current
    this.current = e.detail
    this.name = _$.getKeyByValue(this.inputs, e.detail) || "UNKNOWN"

    if (!this.isPlatformSource(oldSource) && this.isPlatformSource(e.detail)) this._toPlatform()
    else if (this.isPlatformSource(oldSource) && !this.isPlatformSource(e.detail)) this._toExternal()

    _$.vue.$emit("sourceChanged")
  }
  async _toExternal() {
    _$.nav.disable(["exit", "back", "home", "ch_up", "ch_down", "tv", "enter"])
    _$.vue.$once(["nv-exit", "nv-back", "nv-home", "nv-ch_up", "nv-ch_down", "nv-tv"], () => this.setByName("MAIN"))

    if (!this._isEmbeddable() || !this._keepBehind) __.platform.hide()
    this._resizeTvWindowForSource("external")
    __.common._tvWindowSetSize()
  }
  async _toPlatform() {
    if (!this._isEmbeddable() || !this._keepBehind) __.platform.show()
    this._resizeTvWindowForSource("platform")

    this._keepBehind = false
    this.isExternal = false
    __.platform.focus = true
    await __.platform.loadState("media")
    _$.nav.enable()
    _$.vue.$emit("actions", "play")
  }
}

export default new Source()
